<button
  type="button"
  [disabled]="isDisabled()"
  [class]="
    'flex w-full items-center justify-start px-5 py-5 cursor-pointer rounded-(--selectionbutton-border-radius) transition-all border ' +
    (state() === 'selected'
      ? 'bg-(--selectionbutton-selected-background) border-(--selectionbutton-selected-border) ring-1 ring-(--selectionbutton-selected-border)'
      : state() === 'disabled'
        ? 'bg-(--selectionbutton-disabled-background) border-transparent cursor-not-allowed'
        : 'bg-(--selectionbutton-idle-background) border-(--selectionbutton-idle-border) hover:ring-1 hover:ring-(--selectionbutton-selected-border) hover:border-(--selectionbutton-selected-border)')
  "
  style="font-family: var(--selectionbutton-font-family)"
  (click)="onClick()"
>
  <app-dynamic
    componentName="DynamicText"
    [props]="textProps()"
  />
</button>
